/**
 * Loading the admin-managed AI model list — the NETWORK half of
 * features/ai-models, deliberately split from ./store.ts.
 *
 * The split is load-bearing, not tidiness: `core/api.ts` reads
 * `import.meta.env` (a Vite-only global), and the server's e2e harnesses
 * typecheck the client's `GridTable` module for its `GridLayoutSnapshot`
 * type — so anything in that import graph has to compile in a plain Node
 * program too. The pickers import the store; only the app shell, a board
 * open and the admin page import this. (Same rule as features/text-kinds.)
 */
import { fetchAiModelList } from "../../core/api.js";

import { aiModels } from "./store.js";

let inflight: Promise<void> | null = null;

/**
 * (Re)load the list. Coalesces concurrent callers — the app shell and a board
 * opening at the same moment must not issue two requests — and never throws:
 * a failed load keeps whatever the store already holds (an empty list on first
 * load, which every picker renders as "Default only").
 */
export function loadAiModels(): Promise<void> {
  if (inflight !== null) return inflight;
  inflight = fetchAiModelList()
    .then((response) => aiModels.getState().setList(response.models, response.defaults))
    .catch(() => {
      /* keep what we have; the next open retries */
    })
    .finally(() => {
      inflight = null;
    });
  return inflight;
}
